import { isArray, isNumber, isObject, isString } from '../utils/typeUtils';

export type ReleaseTask = {
  taskName: string;
  startsAt: string;
  endsAt: string;
  group: string;
  condition: Condition;
  targets: number[] | null;
  version?: string;
  taskId?: number;
  manifestVersion?: string;
};

export type ReleaseTaskFormField = {
  taskName: string;
  startsAt: Date;
  endsAt: Date;
  group: string;
  condition: Condition;
  targets: number[] | null;
  version?: string;
  taskId?: number;
  // manifestVersion?: string;
};

/**
 * コンポーネント 型ガード
 */
export const isReleaseTask = (arg: unknown): arg is ReleaseTask => {
  const a = arg as ReleaseTask;

  return (
    isObject(a) &&
    isNumber(a.taskId) &&
    isString(a.taskName) &&
    isString(a.startsAt) &&
    isString(a.endsAt) &&
    isString(a.group) &&
    isString(a.condition) &&
    isString(a.manifestVersion)
  );
};

export const isReleaseTasks = (arg: unknown): arg is ReleaseTask[] =>
  isArray(arg, isReleaseTask);

export const isTargetGroups = (arg: unknown): arg is string[] =>
  isArray(arg, isString);

/**
 * 配信対象顧客
 *
 * all: すべての会社に表示
 * include: targets に指定された会社にのみ表示
 * exclude: targets に指定された会社以外にのみ表示
 */
export const CONDITIONS = {
  ALL: 'all',
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
} as const;

/**
 * 配信対象顧客の型
 */
export type Condition = typeof CONDITIONS[keyof typeof CONDITIONS];

/**
 * 配信対象顧客の表示名
 */
const CONDITION_NAMES = {
  [CONDITIONS.ALL]: '全顧客',
  [CONDITIONS.INCLUDE]: '選択された顧客にのみ表示する',
  [CONDITIONS.EXCLUDE]: '選択された顧客以外に表示する',
} as const;

/**
 * 配信対象顧客の表示名を生成
 * @param condition 配信対象顧客のコード値（例: all）
 * @returns 配信対象顧客の表示名（例: 全顧客）
 */
export const createConditionName = (condition: Condition): string =>
  CONDITION_NAMES[condition];

/**
 * タスク一覧のアイテム for ui を生成する
 */

export const mapReleaseTaskToFormFields = ({
  taskName = '',
  startsAt = '',
  endsAt = '',
  group = '',
  condition = CONDITIONS.ALL,
  targets = [],
  manifestVersion = '',
  taskId = undefined,
}: Partial<ReleaseTask>): ReleaseTaskFormField => ({
  taskName,
  startsAt: startsAt ? new Date(startsAt) : new Date(),
  endsAt: endsAt ? new Date(endsAt) : new Date(),
  version: manifestVersion,
  group,
  condition,
  targets,
  taskId,
});
